/* eslint-disable */
import OsmMapHelper from "../OsmMapHelper";
import ItemOsmMapOther from "../item/ItemOsmMapOther";
import ItemListBase from "./ItemListBase";

class ItemListOthers extends ItemListBase {
  constructor(scene) {
    super(scene);
    this.name = "ItemListOthers";

    super.createRoot();
  }

  create(acc, data, position, size, boundary) {
    data.forEach((item, index) => {
      let create = false;
      let colorBase = 0.25 + Math.random() * 0.75;
      let color = new BABYLON.Color3(colorBase, colorBase, colorBase);
      let width;
      let height;
      let depth;

      if (item.tags["highway"]) {
        if (item.tags["highway"] === "traffic_signals") {
          width = 0.01;
          height = 0.2;
          depth = 0.01;
          color = new BABYLON.Color3(0.75, 0.75, 0.75);
          create = true;
        } else if (item.tags["highway"] === "bus_stop") {
          width = 0.01;
          height = 0.075;
          depth = 0.01;
          color = new BABYLON.Color3(0.75, 0.75, 0.75);
          create = true;
        }
      } else if (item.tags["power"]) {
        if (item.tags["power"] === "tower") {
          width = 0.05;
          height = 0.5;
          depth = 0.05;
          color = new BABYLON.Color3(0.75, 0.75, 0.75);
          create = true;
        }
      } else if (item.tags["amenity"]) {
        if (item.tags["amenity"] === "post_box") {
          width = 0.02;
          height = 0.05;
          depth = 0.02;
          color = new BABYLON.Color3(0.75, 0.75, 0.75);
          create = true;
        }
      }

      if (create) {
        let lon = item.lon;
        let lat = item.lat;

        if (OsmMapHelper.checkPoint(lon, lat, boundary)) {
          //create mesh
          let mesh = BABYLON.MeshBuilder.CreateBox(
            this.name + "_" + index,
            { width: width, height: height, depth: depth },
            this.scene
          );

          let x = lon * size - position.lon * size;
          let z = lat * size - position.lat * size;

          mesh.parent = this.root;
          mesh.setPivotMatrix(BABYLON.Matrix.Translation(0, height / 2, 0));

          mesh.position.x = x;
          mesh.position.y = 0;
          mesh.position.z = z;

          mesh.material = super.createMaterial(
            this.name + "_" + index,
            color,
            1.0,
            0.5
          );

          this.meshList.push(new ItemOsmMapOther(this.scene, mesh));
        }
      }
    });
  }
}
export default ItemListOthers;
